import { fetchCanPostAsOwner } from '../../../repositories/commercial-owner/v1/can-post-as-owner';

import { mappers } from './mappers';
import {
  ECanPublishAsOwnerStatus,
  ICanPublishAsOwnerDependencies,
  ICanPublishAsOwnerResult,
} from './types';

export const getUserCanPublishAsCommercialOwner = async (
  dependencies: ICanPublishAsOwnerDependencies,
): Promise<ICanPublishAsOwnerResult> => {
  const { httpApi, logger, parameters } = dependencies;

  try {
    return await fetchCanPostAsOwner<ICanPublishAsOwnerResult, ICanPublishAsOwnerResult>({
      httpApi,
      parameters,
      mappers,
    }) as ICanPublishAsOwnerResult;
  } catch (error) {
    logger.error(
      error,
      {
        degradation: 'Запрашивались данные может ли пользователь публиковаться как соб коммерческой',
        description: 'commercial-owner /v1/can-post-as-owner/ rejection error',
        requestParameters: JSON.stringify(parameters),
      },
    );

    return {
      canPostAsOwner: false,
      message: 'commercial-owner /v1/can-post-as-owner/ rejection error',
      status: ECanPublishAsOwnerStatus.CriticalError,
    };
  }
};
